<template>
    <svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 14.5H5M1 4.5C1 2.84 2.79 1.5 5 1.5C7.21 1.5 9 2.84 9 4.5C9 6.16 7.21 7.5 5 7.5C2.79 7.5 1 6.16 1 4.5ZM5 19.5V7.5V19.5ZM3 18.5H5H3Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
<script>
    export default {
	    name: 'CertIconSVG'
    }
</script>

